/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-01-06 18:10:00
 */

 import AlarmList from '../alarmList';
 import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
 import AlarmListApi, { AlarmListDOI } from '../api/alarmListApi';
 import ListPageService from 'src/types/ListPage';
 import override from 'src/dectorators/override';
 import { QueryFormVOI } from 'src/components/queryForm/queryForm';

 import EnumAlaemType from 'src/enums/enumAlaemType';
 import Viewer from 'viewerjs'
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import Input from 'src/types/iview/Input';
 import EnumStationType from 'src/enums/enumStationType';
 import AlarmListDOI from '../api/alarmListApi';
 export default class AlarmListService extends ListPageService {
     ctx: AlarmList;
 
     get type() {
         return EnumStationType.findCode(this.ctx.$route.params.type).getId();
     }
 
     constructor(ctx: DiskConfig) {
         super();
         this.ctx = ctx;
     }
 
 
     @override
     createColumns(): ColDefCustom[] {
         let t = this;
         return [
             {
                 headerName: '站点名称',
                 field: 'device_name',
                 minWidth: 150,
             },
             {
                 headerName: '硬盘机名称',
                 field: 'name',
                 minWidth: 120,
             },
             {
                 headerName: '设备序列号',
                 field: 'deviceserial',
                 minWidth: 100,
             },
             {
                headerName: '报警类型',
                field: 'alarm_type',
                minWidth: 180,
                cellRenderer(params) {
                    let data: AlarmListDOI.RowDataI = params.data;
                    return EnumAlaemType.findId(data.alarm_type).getName();
                },
             },
             {
                headerName: '图片',
                field: 'img',
                minWidth: 250,
                cellRenderer: function(params){
                    let url = params.value;
                    var imageElement = document.createElement("img");
                    imageElement.src = url;
                    imageElement.style.width = 200+'px';
                    imageElement.style.height = 120+'px';
                    return imageElement;
                },
                onCellClicked: function(event) {
                    let container = document.createElement('div');
                    let img = document.createElement('img')
			        img.src = event.data.img
			        container.append(img)
                    var viewer = new Viewer(container, {
                        hidden: function () {
                            viewer.destroy();
                        },
                        toolbar:{
                            zoomIn: true,
                            zoomOut: true,
                            oneToOne: true,
                            reset: true,
                            prev: true,
                            play: true,
                            next: true,
                            rotateLeft: true,
                            rotateRight: true,
                        }
                    });
		            viewer.show();
                },
            },
             {
                 headerName: '时间',
                 field: 'create_time',
                 minWidth: 180,
             },
         ];
     }
 
     @override
     creatQueryForm(): QueryFormVOI.DateItemType[] {
         return [
             {
                 component: EntitySelect,
                 label: '站点：',
                 field: 'device_id',
                 labelWidth: 100,
                 width: 300,
                 props: { value: null, placeholder: '请选择', type: EnumEntity.Station.getId() },
             },
             {
                 component: Input,
                 label: '硬盘机名称：',
                 field: 'name',
                 labelWidth: 100,
                 width: 300,
                 props: { value: '', placeholder: '请输入' },
             },
         ];
     }
 
 
     @override
     initSearchParams(): void {
         this.ctx.searchParams = this.ctx.queryForm.getQueryObj<AlarmListDOI.QueryRowDataParamsI>();
         this.ctx.currentPage = 1;
     }
 
     @override
     async searchTable() {
         let ctx = this.ctx;
         let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
         ag.showLoading();
         ag.rowHeight = 130;
         let { code, data } = await AlarmListApi.searchList({
             ...ctx.searchParams,
             type: this.type,
             page_size: ctx.pageSize,
             page_index: ctx.currentPage,
         });
         ag.hideLoading();
 
         if (code === 0) {
             ctx.rowData = data.data_info || [];
             ctx.total = data.page_count;
         }
     }
 }
 